<template>
  <div class="col-12 col-lg-6">
    <div class="row">
      <div class="col-12">
        <div class="pane-header">
          <span class="icon"><icon-colored-markup /></span>
          <span>{{ capitalize($t('names.markup', { n: 1 })) }}</span>
        </div>
      </div>
      <div class="col-12">
        <div class="pane-content">
          <div class="row">
            <div class="col-6">
              <h4>{{ capitalize($t('names.type', { n: 1 })) }}</h4>
              <span
                id="package_details_start_date"
                class="text-muted"
                >{{ capitalize(feeTypeFormatted) }}</span
              >
            </div>
            <div class="col-6">
              <h4>{{ capitalize($t('names.value', { n: 1 })) }}</h4>
              <span
                id="package_details_end_date"
                class="text-muted"
                >{{ feeValueFormatted }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { capitalize, computed } from 'vue';

  import { IconColoredMarkup } from '@/common/icons/colored';
  import { Package } from '@/common/models';
  import { formatCurrency } from '@/globals';
  import i18n from '@/vueI18n';

  interface IDealDetailsDates {
    deal: Package;
  }

  const { deal } = defineProps<IDealDetailsDates>();

  const hasPercentOrFixedMarkup = computed(() => {
    // If the deal has a fee type, and it's not a fixed CPM, then it has a percent or fixed markup
    return deal.feeType != null && !deal.cpmFixed;
  });

  const feeTypeFormatted = computed(() => {
    return hasPercentOrFixedMarkup.value ? deal.feeTypeFormatted : i18n.global.t('messages.advertiserCPM');
  });

  const feeValueFormatted = computed(() => {
    return hasPercentOrFixedMarkup.value
      ? deal.feeValueFormatted
      : formatCurrency(deal.cpmFixed || 0, { currencyCode: deal.currencyInformation.currency });
  });
</script>

<style lang="scss" scoped>
  @use '@/styles/variables.scss' as *;
</style>
